/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { unsetUserData } from '@/redux/slices/user/actions';

import { AnimalAlertPopoverState } from './types';

const initialState: AnimalAlertPopoverState = {
  isOpen: true,
};

const animalAlertPopoverSlice = createSlice({
  name: 'animalAlertPopover',
  initialState,
  reducers: {
    openAnimalAlertPopover: (state) => {
      state.isOpen = true;
    },
    closeAnimalAlertPopover: (state) => {
      state.isOpen = false;
    },
    toggleAnimalAlertPopover: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unsetUserData, () => initialState);
  },
});

export default animalAlertPopoverSlice;
